module.exports = __webpack_public_path__ + "static/img/user-full.988db51b.png";